// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","blue":"Card_blue__esrrf"};